import React from "react";

export default function MoaAndAoa() {
  return (
    <div id="content">
      <section className="welcome padding-top-50 padding-bottom-50">
        <div className="container">
          <div className="heading blck">
            <div className="text-center">
              <h3>Memorandum of Association & Articles of Association</h3>
              <hr />
            </div>

            <ul className="dwbutton">
              <li>
                <a
                  href="assets/investor_relation/MOA & AOA/Memorandum Of Association & Articles Of Association.pdf"
                  target="_blank"
                >
                  <i className="fa fa-angle-double-right"></i>Memorandum of Association & Articles of Association
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
